/**
 * Auth0-specific types for Architeia
 * Extends the shared types with Auth0-specific claims and user data
 */
/**
 * Auth0 custom claims namespace
 */
export const ARCHITEIA_NAMESPACE = 'https://architeia.org/';
